import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
const T3 = '#98A2B3';
export default function CommonFooter() {
    return (_jsxs(Box, { sx: {
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
            py: 3,
            mt: 'auto'
        }, children: [_jsx(Box, { component: "img", src: "/assets/loginImage/logo-final.svg", alt: "", sx: { height: 16, opacity: 0.35 } }), _jsxs(Typography, { sx: { fontSize: '0.72rem', color: T3 }, children: ["\u00A9 ", new Date().getFullYear(), " Group 8A. All rights reserved."] })] }));
}
